export default __webpack_public_path__ + "static/media/services-1.aa0de3d9.png";